module.exports = __webpack_public_path__ + "img/alter-white.a3c0e9b5.png";